import Icon from "@ant-design/icons";
import { Button, Form, Input, Switch } from "antd";
import React from "react";
import EngagedAI from "../../../../static/EngagedAi_trans_bg.svg";
import { RichTextEditorJSX } from "../../userSettings/RichTextEditor";

export const TextInputJSX = ({
  isEmail,
  setCampaignData,
  index,
  internalIndex,
  sourceId,
  setIsAfterHour,
  setMessageIndex,
  setLoading,
  getAIResponse,
  user,
  useCases,
  buildCampaignInput,
  loading,
  campaignData,
  targetKey,
  mode,
  targetObject,
}) => {
  const isAfterHour = ["afterHourTemplateText", "afterHourEmailTemplateText"].includes(targetKey);
  return (
    <>
      {isEmail && (
        <div className="border-1 p-2 flex-row-centered gap-1 border-grey-200">
          <Form.Item
            rules={[{ required: false, message: "Please enter Email subject" }]}
            label={<span className="text-grey-700 xs-600">Subject</span>}
            className="w-full pb-0 mb-0"
          >
            <Input
              value={
                targetKey === "afterHourEmailTemplateText"
                  ? targetObject?.afterHourEmailSubjectText
                  : targetObject?.emailSubjectText
              }
              onChange={e =>
                setCampaignData(prev => {
                  const temp = structuredClone(prev).messages;
                  temp[index] = {
                    ...temp[index],
                    isChanged: true,
                  };
                  temp[index].campaignTemplates[internalIndex === "all" ? 0 : internalIndex + 1] = {
                    ...temp[index].campaignTemplates[
                      internalIndex === "all" ? 0 : internalIndex + 1
                    ],
                    ...(targetKey === "afterHourEmailTemplateText"
                      ? { afterHourEmailSubjectText: e.target.value }
                      : { emailSubjectText: e.target.value }),
                    sourceId: sourceId,
                  };
                  return { ...prev, messages: temp };
                })
              }
              name={
                targetKey === "afterHourEmailTemplateText"
                  ? "afterHourEmailSubjectText"
                  : "emailSubjectText"
              }
              className="border-none focus:border-none"
            />
          </Form.Item>
        </div>
      )}
      <Form.Item name={targetKey}>
        <RichTextEditorJSX
          name={targetKey}
          formData={targetObject}
          wysiwygTextEditor={isEmail}
          changingKey={targetKey}
          subject={
            targetKey === "afterHourEmailTemplateText"
              ? targetObject?.afterHourEmailSubjectText
              : targetObject?.emailSubjectText
          }
          setformData={value => {
            setCampaignData(prev => {
              const temp = structuredClone(prev).messages;
              temp[index] = {
                ...temp[index],
                isChanged: true,
              };
              if (mode === "ADD") {
                temp[index].campaignTemplates[internalIndex === "all" ? 0 : internalIndex + 1] = {
                  ...temp[index].campaignTemplates[internalIndex === "all" ? 0 : internalIndex + 1],
                  sourceId: sourceId,
                  [targetKey]: value[targetKey],
                };
              } else {
                const objIndex = temp[index].campaignTemplates.findIndex(
                  item => item?.sourceId === targetObject?.sourceId
                );
                if (objIndex !== -1) {
                  temp[index].campaignTemplates[objIndex] = {
                    ...temp[index].campaignTemplates[objIndex],
                    [targetKey]: value[targetKey],
                  };
                }
              }
              return { ...prev, messages: temp };
            });
          }}
          leftActionJSX={
            <Button
              className="flex-row-centered gap-1"
              key="campaignMessageSuggestion"
              onClick={() => {
                setIsAfterHour(false);
                setMessageIndex(index);
                setLoading(true);
                getAIResponse({
                  variables: {
                    companyId: +user?.company?.id,
                    applicationUseCaseId: +useCases?.getApplicationUseCases?.filter(
                      useCase => useCase.code === "CAMPAIGN_MESSAGE_SUGGESTION"
                    )[0]?.id,
                    campaignInput: buildCampaignInput(),
                  },
                });
              }}
              loading={loading}
              type="text"
            >
              <span className="text-sm font-[400]  text-brand-500">
                <span>Generate</span>{" "}
                <Icon component={EngagedAI} alt="EngagedAi" className="mt-0.5" />
              </span>{" "}
            </Button>
          }
          rightActionsJsx={
            <div className="flex-row-centered gap-1 items-center">
              {campaignData.campaignType === "AUTOMATED" && !isAfterHour && (
                <div className="flex-row-centered items-center xs-400 text-grey-700 gap-2">
                  <Switch
                    size="small"
                    value={targetObject?.useAsTemplate}
                    onChange={checked =>
                      setCampaignData(prev => {
                        const temp = structuredClone(prev).messages;
                        temp[index] = {
                          ...temp[index],
                          isChanged: true,
                        };
                        temp[index].campaignTemplates[
                          internalIndex === "all" ? 0 : internalIndex + 1
                        ] = {
                          ...temp[index].campaignTemplates[
                            internalIndex === "all" ? 0 : internalIndex + 1
                          ],
                          useAsTemplate: checked,
                        };
                        return { ...prev, messages: temp };
                      })
                    }
                  />
                  Use entered text as a template
                </div>
              )}
              {/* <Button
                  onClick={() =>
                    setpreviewState({
                      visible: true,
                      data: targetObject,
                      isEmail: isEmail,
                      targetKey,
                    })
                  }
                  className="border-[1px] mr-2 px-2 py-0.5 border-solid bg-white"
                >
                  Preview
                </Button> */}
            </div>
          }
          className="min-h-[150px] p-2 hover:shadow-inner w-full"
        />
      </Form.Item>
    </>
  );
};
